(function (exports) {

  // Модель Пользователь. Конструктор.
  var User = exports.User = function (data) {
    _.extend(this, data);
  }

  User.prototype.constructor = User;
  User.prototype.toString = function () {
    return "[object models.User]";
  }

  // Получает текущего пользователя.
  User.current = function () {
    return User._current;
  }  

})(this.models || (this.models = {}));